import classNames from "classnames";
import { observer } from "mobx-react";
import React from "react";
import { useHistory } from "react-router-dom";

import { useMainStore } from "@/contexts/Store";
import { relatedRecord } from "@/stores/types/control-types";

type Props = {
  recordVersionID: number;
  items?: relatedRecord[];
  locked?: boolean;
  pinned?: boolean;
  width?: number;
};

function Controls({ width, recordVersionID, items, pinned, locked }: Props) {
  // Import MobX stores
  const mainStore = useMainStore();

  // Variables
  const history = useHistory();
  const { themisModuleIdentifier, workspaceID } = mainStore.context;
  const { isCurrentWorkspaceArchived, isCurrentWorkspaceActive } =
    mainStore.workspaces;
  const { hasModuleWriteAccess } = mainStore.userPermissions;
  const isReadOnly = !hasModuleWriteAccess || isCurrentWorkspaceArchived;

  // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
  const filteredControls = items.filter(
    (record) =>
      !["risk_register", "control_mapping"].includes(
        // @ts-expect-error TS(2345) FIXME: Argument of type 'string | undefined' is not assig... Remove this comment to see the full error message
        record.themis_module_identifier,
      ),
  );
  const count = filteredControls.length;
  const liClassNames = classNames("controls-cell", {
    pinned,
    "locked-cell": locked && isCurrentWorkspaceActive,
    "table-cell--disabled": isReadOnly,
    "pointer-events-none": locked || isReadOnly,
  });

  // Functions
  const handleCellClick = () => {
    if (themisModuleIdentifier === "issue_management") {
      return history.push(
        `/workspaces/${workspaceID}/modules/issue-management/${recordVersionID}/controls`,
      );
    }
    history.push(
      `/workspaces/${workspaceID}/modules/risk-register/${recordVersionID}/controls`,
    );
  };

  return (
    <li
      className={liClassNames}
      style={{ width }}
      data-testid="rr-control-cell"
      onClick={handleCellClick}
    >
      <div className="cell-content">
        <span
          className={classNames("controls-cell-value", {
            "with-value": count > 0,
          })}
        >
          {count > 0 ? `${count} Controls added` : "- Add Module Controls -"}
        </span>
      </div>
    </li>
  );
}

Controls.defaultProps = {
  width: 200,
  items: [],
};

export default observer(Controls);
